<ng-container [formGroup]="form">
  <div class="question-content" *ngIf="languageVisibility.de">
    <label [for]="'question_de'">{{ 'scrudu.languages.de' | translate }}</label>
    <qf-rich-editor
      [id]="'question_de'"
      #editor="richEditor"
      formControlName="contentDe"
    ></qf-rich-editor>
    <qf-input-feedback
      [validations]="validations?.content?.de"
      [inputField]="editor"
      [inputValue]="form.get('contentDe')?.value"
    ></qf-input-feedback>
  </div>
  <div class="question-content" *ngIf="languageVisibility.fr">
    <label [for]="'question_fr'">{{ 'scrudu.languages.fr' | translate }}</label>
    <qf-rich-editor
      [id]="'question_fr'"
      #editor="richEditor"
      formControlName="contentFr"
    ></qf-rich-editor>
    <qf-input-feedback
      [validations]="validations?.content?.fr"
      [inputField]="editor"
      [inputValue]="form.get('contentFr')?.value"
    ></qf-input-feedback>
  </div>
  <div class="question-content" *ngIf="languageVisibility.en">
    <label [for]="'question_en'">{{ 'scrudu.languages.en' | translate }}</label>
    <qf-rich-editor
      [id]="'question_en'"
      #editor="richEditor"
      formControlName="contentEn"
    ></qf-rich-editor>
    <qf-input-feedback
      [validations]="validations?.content?.en"
      [inputField]="editor"
      [inputValue]="form.get('contentEn')?.value"
    ></qf-input-feedback>
  </div>
  <div class="question-content" *ngIf="languageVisibility.it">
    <label [for]="'question_it'">{{ 'scrudu.languages.it' | translate }}</label>
    <qf-rich-editor
      [id]="'question_it'"
      #editor="richEditor"
      formControlName="contentIt"
    ></qf-rich-editor>
    <qf-input-feedback
      [validations]="validations?.content?.it"
      [inputField]="editor"
      [inputValue]="form.get('contentIt')?.value"
    ></qf-input-feedback>
  </div>

  <div class="question-video" *ngIf="languageVisibility.de">
    <co-single-panel-accordion
      title="{{ 'video_upload.title' | translateToLanguage : 'de' | async }}"
      [initiallyOpen]="!!form.get('videoDe')?.value"
    >
      <qf-video-upload formControlName="videoDe"></qf-video-upload>
    </co-single-panel-accordion>
  </div>
  <div class="question-video" *ngIf="languageVisibility.fr">
    <co-single-panel-accordion
      title="{{ 'video_upload.title' | translateToLanguage : 'fr' | async }}"
      [initiallyOpen]="!!form.get('videoFr')?.value"
    >
      <qf-video-upload formControlName="videoFr"></qf-video-upload>
    </co-single-panel-accordion>
  </div>
  <div class="question-video" *ngIf="languageVisibility.en">
    <co-single-panel-accordion
      title="{{ 'video_upload.title' | translateToLanguage : 'en' | async }}"
      [initiallyOpen]="!!form.get('videoEn')?.value"
    >
      <qf-video-upload formControlName="videoEn"></qf-video-upload>
    </co-single-panel-accordion>
  </div>
  <div class="question-video" *ngIf="languageVisibility.it">
    <co-single-panel-accordion
      title="{{ 'video_upload.title' | translateToLanguage : 'it' | async }}"
      [initiallyOpen]="!!form.get('videoIt')?.value"
    >
      <qf-video-upload formControlName="videoIt"></qf-video-upload>
    </co-single-panel-accordion>
  </div>

  <div
    class="propositions"
    *ngIf="languageVisibility.de"
    formArrayName="propositions"
  >
    <label>{{ 'scrudu.languages.de' | translate }}</label>
    <div
      class="skin-container skin-container--default"
      [dndDropzone]="['de']"
      dndEffectAllowed="move"
      (dndDrop)="responseOptionMoved($event)"
      #propositionsContainer
    >
      <div class="proposition proposition--placeholder" dndPlaceholderRef></div>
      <div
        *ngFor="
          let propositionFormGroup of propositionsForm.controls;
          index as index
        "
        [formGroupName]="index"
        class="proposition"
        [dndDraggable]="index"
        [dndType]="'de'"
        [dndEffectAllowed]="'move'"
      >
        <co-radio-button-group
          [ngModel]="propositionFormGroup.get('correct')?.value"
          [ngModelOptions]="{ standalone: true }"
        >
          <button
            class="btn btn-secondary-migrated"
            [value]="true"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.correct' | translate }}
          </button>
          <button
            class="btn btn-secondary-migrated"
            [value]="false"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.incorrect' | translate }}
          </button>
        </co-radio-button-group>
        <label [for]="'question_de_option_' + index" class="proposition--label"
          >{{ index | indexAsCharacter }})</label
        >
        <div class="proposition--editor" *ngIf="!isRearranging">
          <qf-rich-editor
            [id]="'question_de_option_' + index"
            #editor="richEditor"
            formControlName="contentDe"
          ></qf-rich-editor>
          <qf-input-feedback
            [validations]="
              (validations?.propositions || [])[index]?.content?.de
            "
            [inputField]="editor"
            [inputValue]="propositionFormGroup.get('contentDe')?.value"
          ></qf-input-feedback>
        </div>
        <i
          class="fa fa-bars fa-lg fa-rounded-border proposition--drag-handle"
          dndHandle
        ></i>
      </div>
    </div>
    <qf-input-feedback
      [validations]="validations?.kPrimeSolution"
      [inputField]="propositionsContainer"
      [inputValue]="helperForm.get('allPropositionSolutionsSelected')?.value"
    ></qf-input-feedback>
  </div>
  <div
    class="propositions"
    *ngIf="languageVisibility.fr"
    formArrayName="propositions"
  >
    <label>{{ 'scrudu.languages.fr' | translate }}</label>
    <div
      class="skin-container skin-container--default"
      [dndDropzone]="['fr']"
      dndEffectAllowed="move"
      (dndDrop)="responseOptionMoved($event)"
      #propositionsContainer
    >
      <div class="proposition proposition--placeholder" dndPlaceholderRef></div>
      <div
        *ngFor="
          let propositionFormGroup of propositionsForm.controls;
          index as index
        "
        [formGroupName]="index"
        class="proposition"
        [dndDraggable]="index"
        [dndType]="'fr'"
        [dndEffectAllowed]="'move'"
      >
        <co-radio-button-group
          [ngModel]="propositionFormGroup.get('correct')?.value"
          [ngModelOptions]="{ standalone: true }"
        >
          <button
            class="btn btn-secondary-migrated"
            [value]="true"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.correct' | translate }}
          </button>
          <button
            class="btn btn-secondary-migrated"
            [value]="false"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.incorrect' | translate }}
          </button>
        </co-radio-button-group>
        <label [for]="'question_fr_option_' + index" class="proposition--label"
          >{{ index | indexAsCharacter }})</label
        >
        <div class="proposition--editor" *ngIf="!isRearranging">
          <qf-rich-editor
            [id]="'question_fr_option_' + index"
            #editor="richEditor"
            formControlName="contentFr"
          ></qf-rich-editor>
          <qf-input-feedback
            [validations]="
              (validations?.propositions || [])[index]?.content?.fr
            "
            [inputField]="editor"
            [inputValue]="propositionFormGroup.get('contentFr')?.value"
          ></qf-input-feedback>
        </div>
        <i
          class="fa fa-bars fa-lg fa-rounded-border proposition--drag-handle"
          dndHandle
        ></i>
      </div>
    </div>
    <qf-input-feedback
      [validations]="validations?.kPrimeSolution"
      [inputField]="propositionsContainer"
      [inputValue]="helperForm.get('allPropositionSolutionsSelected')?.value"
    ></qf-input-feedback>
  </div>
  <div
    class="propositions"
    *ngIf="languageVisibility.en"
    formArrayName="propositions"
  >
    <label>{{ 'scrudu.languages.en' | translate }}</label>
    <div
      class="skin-container skin-container--default"
      [dndDropzone]="['en']"
      dndEffectAllowed="move"
      (dndDrop)="responseOptionMoved($event)"
      #propositionsContainer
    >
      <div class="proposition proposition--placeholder" dndPlaceholderRef></div>
      <div
        *ngFor="
          let propositionFormGroup of propositionsForm.controls;
          index as index
        "
        [formGroupName]="index"
        class="proposition"
        [dndDraggable]="index"
        [dndType]="'en'"
        [dndEffectAllowed]="'move'"
      >
        <co-radio-button-group
          [ngModel]="propositionFormGroup.get('correct')?.value"
          [ngModelOptions]="{ standalone: true }"
        >
          <button
            class="btn btn-secondary-migrated"
            [value]="true"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.correct' | translate }}
          </button>
          <button
            class="btn btn-secondary-migrated"
            [value]="false"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.incorrect' | translate }}
          </button>
        </co-radio-button-group>
        <label [for]="'question_en_option_' + index" class="proposition--label"
          >{{ index | indexAsCharacter }})</label
        >
        <div class="proposition--editor" *ngIf="!isRearranging">
          <qf-rich-editor
            [id]="'question_en_option_' + index"
            #editor="richEditor"
            formControlName="contentEn"
          ></qf-rich-editor>
          <qf-input-feedback
            [validations]="
              (validations?.propositions || [])[index]?.content?.en
            "
            [inputField]="editor"
            [inputValue]="propositionFormGroup.get('contentEn')?.value"
          ></qf-input-feedback>
        </div>
        <i
          class="fa fa-bars fa-lg fa-rounded-border proposition--drag-handle"
          dndHandle
        ></i>
      </div>
    </div>
    <qf-input-feedback
      [validations]="validations?.kPrimeSolution"
      [inputField]="propositionsContainer"
      [inputValue]="helperForm.get('allPropositionSolutionsSelected')?.value"
    ></qf-input-feedback>
  </div>
  <div
    class="propositions"
    *ngIf="languageVisibility.it"
    formArrayName="propositions"
  >
    <label>{{ 'scrudu.languages.it' | translate }}</label>
    <div
      class="skin-container skin-container--default"
      [dndDropzone]="['it']"
      dndEffectAllowed="move"
      (dndDrop)="responseOptionMoved($event)"
      #propositionsContainer
    >
      <div class="proposition proposition--placeholder" dndPlaceholderRef></div>
      <div
        *ngFor="
          let propositionFormGroup of propositionsForm.controls;
          index as index
        "
        [formGroupName]="index"
        class="proposition"
        [dndDraggable]="index"
        [dndType]="'it'"
        [dndEffectAllowed]="'move'"
      >
        <co-radio-button-group
          [ngModel]="propositionFormGroup.get('correct')?.value"
          [ngModelOptions]="{ standalone: true }"
        >
          <button
            class="btn btn-secondary-migrated"
            [value]="true"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.correct' | translate }}
          </button>
          <button
            class="btn btn-secondary-migrated"
            [value]="false"
            (click)="propositionClicked(propositionFormGroup, $event)"
          >
            {{ 'question_groups.edit.incorrect' | translate }}
          </button>
        </co-radio-button-group>
        <label [for]="'question_it_option_' + index" class="proposition--label"
          >{{ index | indexAsCharacter }})</label
        >
        <div class="proposition--editor" *ngIf="!isRearranging">
          <qf-rich-editor
            [id]="'question_it_option_' + index"
            #editor="richEditor"
            formControlName="contentIt"
          ></qf-rich-editor>
          <qf-input-feedback
            [validations]="
              (validations?.propositions || [])[index]?.content?.it
            "
            [inputField]="editor"
            [inputValue]="propositionFormGroup.get('contentIt')?.value"
          ></qf-input-feedback>
        </div>
        <i
          class="fa fa-bars fa-lg fa-rounded-border proposition--drag-handle"
          dndHandle
        ></i>
      </div>
    </div>
    <qf-input-feedback
      [validations]="validations?.kPrimeSolution"
      [inputField]="propositionsContainer"
      [inputValue]="helperForm.get('allPropositionSolutionsSelected')?.value"
    ></qf-input-feedback>
  </div>
</ng-container>
